var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "print" } }, [
    _c(
      "div",
      { staticClass: "book m-auto" },
      _vm._l(
        Math.ceil(_vm.goodsreceipt.orders.length / _vm.maxOrderLists),
        function(data, idx) {
          return _c("div", { key: idx, staticClass: "page" }, [
            _c("div", { staticClass: "subpage" }, [
              _c(
                "div",
                {
                  staticClass: "top-header",
                  staticStyle: { padding: "0 0 30px 0" }
                },
                [
                  idx == 0
                    ? _c("div", { staticClass: "company-info" }, [
                        _vm.shopInfo.logo.thumbnail
                          ? _c("img", {
                              attrs: { src: _vm.shopInfo.logo.thumbnail }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "name" }, [
                          _c("strong", { staticClass: "text-black" }, [
                            _vm._v(_vm._s(_vm.shopInfo.shop_name))
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.shopInfo.info.location.address))
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "document-type" }, [
                    _c("h2", { staticClass: "text-black" }, [
                      _vm._v(_vm._s(_vm.$t("documents.gr")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.goodsreceipt.gr_code))])
                  ])
                ]
              ),
              _vm._v(" "),
              idx == 0
                ? _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "left" }, [
                      _c("div", { staticClass: "section" }, [
                        _c("p", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("message.vendor")))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "detail" }, [
                          _vm._v(_vm._s(_vm.goodsreceipt.vendor.vendor_name))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.getPartnerContact(_vm.goodsreceipt.vendor.contacts)
                        .tel
                        ? _c("div", { staticClass: "section" }, [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("message.tel")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "detail" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getPartnerContact(
                                    _vm.goodsreceipt.vendor.contacts
                                  ).tel
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.goodsreceipt.vendor.address
                        ? _c("div", { staticClass: "section" }, [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("message.address")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "detail" }, [
                              _vm._v(_vm._s(_vm.goodsreceipt.vendor.address))
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c("div", { staticClass: "section" }, [
                        _c("p", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("apps.inventory.message.receiptdate"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "detail" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getDateTime(_vm.goodsreceipt.scheduled_at)
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section" }, [
                        _c("p", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "apps.inventory.message.postingatreceivedorders"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "detail" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.goodsreceipt.posting_at
                                  ? _vm.getDateTime(_vm.goodsreceipt.posting_at)
                                  : "-"
                              ) +
                              "\n              "
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "order" }, [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "40%" } }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("message.description")))])
                      ]),
                      _vm._v(" "),
                      _vm.showBinColumn
                        ? _c("td", [
                            _c("b", [
                              _vm._v(_vm._s(_vm.$t("apps.inventory.label.bin")))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("message.quantity")))])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("status.gr.done")))])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.groupOrders[idx].orders, function(ref, idx_) {
                      var item = ref.item
                      var quantity = ref.quantity
                      var done = ref.done
                      var bin_location_id = ref.bin_location_id
                      return _c("tr", { key: idx_ }, [
                        _c("td", { attrs: { width: "10px" } }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.maxOrderLists * idx + (idx_ + 1)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { width: "40%" } }, [
                          _vm._v(_vm._s(item))
                        ]),
                        _vm._v(" "),
                        _vm.showBinColumn
                          ? _c("td", [
                              _vm._v(_vm._s(_vm.getBinNameBy(bin_location_id)))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(_vm._s(_vm.getNumber(quantity)))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(_vm._s(_vm.getNumber(done)))
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              Math.ceil(_vm.goodsreceipt.orders.length / _vm.maxOrderLists) >
                0 &&
              idx !==
                Math.ceil(_vm.goodsreceipt.orders.length / _vm.maxOrderLists) -
                  1
                ? _c("div", { staticClass: "next-page" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.havenextpage")) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              idx >=
              Math.ceil(_vm.goodsreceipt.orders.length / _vm.maxOrderLists) - 1
                ? _c("div", { staticClass: "footer" }, [
                    _c("div", { staticClass: "note" }, [
                      _vm.goodsreceipt.note
                        ? _c("div", { staticClass: "section" }, [
                            _c("p", [_vm._v(_vm._s(_vm.$t("message.note")))]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "white-space": "normal",
                                  "word-wrap": "break-word",
                                  "overflow-wrap": "break-word"
                                }
                              },
                              [_vm._v(_vm._s(_vm.goodsreceipt.note))]
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "total" }, [
                      _c("div", { staticClass: "section" }, [
                        _c("div", { staticClass: "section row m-0" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$t("apps.inventory.message.shipto")
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "detail text-right" }, [
                            _c(
                              "span",
                              { staticClass: "text-underline-border" },
                              [_vm._v(_vm._s(_vm.warehouseName))]
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ])
        }
      ),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { width: "10px" } }, [_c("b", [_vm._v("#")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-703d0e34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703d0e34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/goodsreceipt/include/PrintGr.vue
// module id = null
// module chunks = 